import { Box } from '@ouster/webviz-react-components';

export default function UserPermissionLookUp() {
  return (
    <Box
      display="flex"
      placeItems="center"
      justifyContent="center"
      h="full"
      fontSize="2xl"
    >
      User Permission LookUp (coming soon...)
    </Box>
  );
}
